import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { supabase } from '../lib/supabaseClient';
import { useNavigate, Link } from 'react-router-dom';

function Pricing() {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);

  useEffect(() => {
    document.title = "Pricing | TheSkinnyAI";
    const canonicalLink = document.querySelector("link[rel='canonical']");
    if (canonicalLink) {
      canonicalLink.setAttribute("href", "https://theskinnyai.com/pricing");
    } else {
      const link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      link.setAttribute("href", "https://theskinnyai.com/pricing");
      document.head.appendChild(link);
    }
    // Update og:url to match canonical
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute("content", "https://theskinnyai.com/pricing");
    }
    const desc = document.querySelector('meta[name="description"]');
    if (desc) {
      desc.setAttribute("content", "Transparent pricing for TheSkinnyAI. Plans from $199/mo for AI-powered B2B lead qualification, visitor engagement, and sales pipeline acceleration.");
    }
  }, []);

  React.useEffect(() => {
    let unsub = () => {};
    (async () => {
      const session = (await supabase.auth.getSession()).data.session;
      setIsLoggedIn(!!session);
      const sub = supabase.auth.onAuthStateChange((_event, s) => {
        setIsLoggedIn(!!s?.user);
      });
      unsub = sub.data.subscription?.unsubscribe || (() => {});
    })();
    return () => { try { unsub(); } catch (_) {} };
  }, []);
  function handleCta() {
    if (!isLoggedIn) {
      navigate('/signup?intent=pricing');
    } else {
      navigate('/account?tab=billing');
    }
  }
  const ctaLabel = isLoggedIn ? 'Manage Subscription' : 'Get Started';
  return (
    <main>
      <style>{`
        .badge-enterprise{
          position: relative;
          display: inline-block;
          padding: .35em .65em;
          border-radius: 999px;
          font-weight: 600;
          font-size: .75rem;
          line-height: 1;
          border-radius: 10rem;
          color: #ffffff;
          background: linear-gradient(180deg,#cbd5e1 0%,#94a3b8 55%,#e2e8f0 100%);
          border: 1px solid rgba(100,116,139,.6);
          box-shadow: inset 0 1px rgba(255,255,255,.7);
          overflow: hidden;
        }
        .badge-enterprise::after{
          content: "";
          position: absolute;
          inset: 0;
          /* very subtle moving highlight */
          background: linear-gradient(120deg,
            transparent 0%,
            rgba(255,255,255,.22) 10%,
            rgba(255,255,255,.48) 17%,
            rgba(255,255,255,.22) 24%,
            transparent 36%
          );
          transform: translateX(-120%);
          animation: shimmer-slow 12s linear infinite;
        }
        @media (max-width: 575.98px){
          .badge-enterprise,
          .badge-gold,
          .badge-popular{
            font-size: .75rem;
            padding: .15rem .5rem;
          }
        }
        /* Gold badge for Team */
        .badge-gold{
          position: relative;
          display: inline-block;
          padding: .35em .65em;
          border-radius: 999px;
          font-weight: 600;
          font-size: .75rem;
          line-height: 1;
          border-radius: 10rem;
          color: #ffffff;
          background: linear-gradient(180deg,#ffd166 0%,#f4a307 55%,#ffbe3b 100%);
          border: 1px solid rgba(244,163,7,.6);
          box-shadow: inset 0 1px rgba(255,255,255,.7);
          overflow: hidden;
        }
        /* Solid, non-shimmer green badge for Most Popular */
        .badge-popular{
          display: inline-block;
          padding: .35em .65em;
          border-radius: 999px;
          font-weight: 600;
          font-size: .75rem;
          line-height: 1;
          border-radius: 10rem;
          color: #ffffff;
          background: linear-gradient(180deg,#28a745 0%, #198754 60%, #157347 100%);
          border: 1px solid rgba(21,115,71,.7);
          box-shadow: inset 0 1px rgba(255,255,255,.7);
        }
        .badge-gold::after{
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(120deg,
            transparent 0%,
            rgba(255,255,255,.28) 8%,
            rgba(255,255,255,.6) 16%,
            rgba(255,255,255,.28) 24%,
            transparent 36%
          );
          transform: translateX(-120%);
          animation: shimmer-slow 10s linear infinite;
        }
        @keyframes shimmer-slow{
          from { transform: translateX(-120%); }
          to   { transform: translateX(120%); }
        }
        @media (prefers-reduced-motion: reduce){
          .badge-enterprise::after{
            animation: none;
          }
          .badge-gold::after{
            animation: none;
          }
        }
        .plan-enterprise{
          position: relative;
          border-color: #e5e7eb !important;
        }
        .plan-enterprise::before{
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          height: 4px;
          background: linear-gradient(90deg,#ffffff, #e5e7eb, #ffffff);
          border-top-left-radius: .375rem;
          border-top-right-radius: .375rem;
        }
        .plan-team{
          border-width: 3px !important;
          border-color: #0d6efd !important;
          min-height: 580px;
          margin-top: -20px;
          margin-bottom: 20px;
        }
        .badge-team{
          position: relative;
          display: inline-block;
          padding: .35em .65em;
          border-radius: 10rem;
          font-weight: 600;
          font-size: .75rem;
          line-height: 1;
          color: #ffffff;
          background: linear-gradient(180deg,#b3d4ff 0%,#3b82f6 55%,#1d4ed8 100%);
          border: 1px solid rgba(37,99,235,.6);
          box-shadow: inset 0 1px rgba(255,255,255,.7);
          overflow: hidden;
        }
        .badge-team::after{
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(120deg, transparent 0%, rgba(255,255,255,.28) 8%, rgba(255,255,255,.55) 16%, rgba(255,255,255,.28) 24%, transparent 36%);
          transform: translateX(-120%);
          animation: shimmer-slow 10s linear infinite;
        }
        /* Prevent header wrap at md+ so badges stay on the same line */
        @media (min-width: 768px){
          .plan-header{ flex-wrap: nowrap !important; }
          .plan-header h2{ flex: 1 1 auto; min-width: 0; margin-bottom: 0; font-size: 1.25rem; }
          .badge-gold,.badge-team,.badge-enterprise{ flex-shrink: 0; white-space: nowrap; }
        }
        @media (min-width: 992px){
          .plan-header h2{ font-size: 1.35rem; }
        }
        @media (min-width: 1200px){
          .plan-header h2{ font-size: 1.5rem; }
        }
      `}</style>
      <section className="py-5 bg-light border-bottom">
        <Container>
          <h1 className="display-6 fw-bold text-center mb-3">Pricing for TheSkinnyAI</h1>
          <p className="lead text-muted text-center mx-auto" style={{maxWidth:'900px'}}>
            Choose a plan that fits your team today, and scale as your needs grow. Plans include seat, site, page, and chat allowances with clear limits.
          </p>
        </Container>
      </section>

      <section className="py-5">
        <Container>
          <Row className="g-4 row-cols-1 row-cols-md-2 row-cols-lg-3">
            {/* Pro (formerly Professional/Basic) */}
            <Col>
              <Card className="h-100 shadow-sm">
                <Card.Body className="p-4 d-flex flex-column h-100">
                  <div className="plan-header d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <h2 className="h4 fw-bold mb-1">Pro</h2>
                  </div>
                  <div className="text-muted mb-2">Turn every visitor into a lead</div>
                  <div className="d-flex align-items-baseline gap-2 mb-1">
                    <div className="display-6 fw-bold text-primary">$199.99</div>
                    <div className="small text-muted">USD</div>
                  </div>
                  <div className="text-muted mb-3">Per month</div>
                  <ul className="mb-4">
                    <li>Seats: 1</li>
                    <li>Sites: 1</li>
                    <li>Crawls per month: 15</li>
                    <li>Indexed pages: 200 per site</li>
                    <li>Max tokens per page: 10,000</li>
                    <li>Chat messages: 10,000 / month</li>
                  </ul>
                <div className="mt-auto d-grid gap-2">
                  <Button variant="primary" onClick={handleCta}>{ctaLabel}</Button>
                  <Link to="/roi-calculator" className="text-center text-muted small text-decoration-none mt-1">Not sure? Try our ROI Calculator.</Link>
                </div>
                </Card.Body>
              </Card>
            </Col>
            {/* Team (formerly Enterprise) */}
            <Col>
              <Card className="h-100 shadow-sm border-primary plan-team">
                <Card.Body className="p-4 d-flex flex-column h-100">
                  <div className="plan-header d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <h2 className="h4 fw-bold mb-1">Team</h2>
                    <span className="badge-team">Most Popular</span>
                  </div>
                  <div className="text-muted mb-2">Scale leads across teams</div>
                  <div className="d-flex align-items-baseline gap-2 mb-1">
                    <div className="display-6 fw-bold text-primary">$399.99</div>
                    <div className="small text-muted">USD</div>
                  </div>
                  <div className="text-muted mb-3">Per month</div>
                  <ul className="mb-4">
                    <li>Seats: 5</li>
                    <li>Sites: 1</li>
                    <li>Crawls per month: 30</li>
                    <li>Indexed pages: 500 per site</li>
                    <li>Max tokens per page: 20,000</li>
                    <li>Chat messages: 25,000 / month</li>
                    <li>Advanced Analysis</li>
                    <li>Optional concierge setup available</li>
                  </ul>
                <div className="mt-auto d-grid gap-2">
                  <Button variant="primary" onClick={handleCta}>{ctaLabel}</Button>
                  <Link to="/roi-calculator" className="text-center text-muted small text-decoration-none mt-1">Not sure? Try our ROI Calculator.</Link>
                </div>
                </Card.Body>
              </Card>
            </Col>
            {/* Enterprise */}
            <Col>
              <Card className="h-100 shadow-sm plan-enterprise">
                <Card.Body className="p-4 d-flex flex-column h-100">
                  <div className="plan-header d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <h2 className="h4 fw-bold mb-1">Enterprise</h2>
                    <span className="badge-enterprise">Expandable</span>
                  </div>
                  <div className="text-muted mb-2">SEO/Site Management Teams/Agencies</div>
                  <div className="d-flex align-items-baseline gap-2 mb-1">
                    <div className="display-6 fw-bold text-primary">$1,499.99</div>
                    <div className="small text-muted">USD</div>
                  </div>
                  <div className="text-muted mb-3">Per month</div>
                  <ul className="mb-4">
                    <li>Seats: 10</li>
                    <li>Sites: 5</li>
                    <li>Crawls per month: 150</li>
                    <li>Indexed pages: 500 per site</li>
                    <li>Max tokens per page: 20,000</li>
                    <li>Chat messages: 25,000 / month</li>
                    <li>Advanced Analysis</li>
                    <li>Optional concierge setup available</li>
                  </ul>
                <div className="mt-auto d-grid gap-2">
                  <Button variant="primary" onClick={handleCta}>{ctaLabel}</Button>
                  <Link to="/roi-calculator" className="text-center text-muted small text-decoration-none mt-1">Not sure? Try our ROI Calculator.</Link>
                </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="pb-5 pt-0">
        <Container>
          {/* Optional: concierge setup card can be shown during upgrade flow instead */}
        </Container>
      </section>
    </main>
  );
}

export default Pricing;


